//
import SlTaxDocumentModel from '@/models/Sale/SlTaxDocument'

/**
 * This class describes a sl tax document.
 * @class      SlTaxDocument (name)
 */
export default class SlTaxDocument extends SlTaxDocumentModel {

	/**
	 * Returns a list representation of the object.
	 * @return     {Object}  List representation of the object.
	 */
	static toList() {

		//
		this.appends = [
			//'account_receivable'
		]

		//
		this.includes = [
			//'g_state',
			'sl_customer',
			'sl_customer_branch_offices',
			//'sl_detail_sale_invoices.wh_product',
		]

		//
		return this
	}
}